/* ============================================================
   VIP OGLEDALA — Sticky "return to bulk offer" bar (product pages)
   Reuses the same sessionStorage keys as the quiz / showcase:
   - vipBulkFlow: '1' once the visitor entered the bulk flow
   - vipBulkOfferSelections: [{id, handle, title}, ...]
============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'vipBulkOfferSelections';
  var FLOW_KEY = 'vipBulkFlow';

  function getSelections() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setSelections(list) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-return-bar]');
    if (!bar) return;

    var hasFlow = false;
    try { hasFlow = sessionStorage.getItem(FLOW_KEY) === '1'; } catch (e) {}
    if (!hasFlow) return;

    bar.hidden = false;
    bar.classList.add('is-visible');

    function syncBodySpacing() {
      document.body.style.paddingTop = bar.getBoundingClientRect().height + 'px';
    }
    syncBodySpacing();
    window.addEventListener('resize', syncBodySpacing);

    var countEl = bar.querySelector('[data-return-bar-count]');
    var countTemplate = bar.getAttribute('data-count-template') || 'На път към офертата: {n}';
    var addBtn = bar.querySelector('[data-action="add-to-offer"]');

    function refresh() {
      var selections = getSelections();
      if (countEl) {
        if (selections.length > 0) {
          countEl.hidden = false;
          countEl.textContent = countTemplate.replace('{n}', selections.length);
        } else {
          countEl.hidden = true;
        }
      }
      if (addBtn) {
        var id = addBtn.getAttribute('data-product-id');
        var added = selections.some(function (s) { return String(s.id) === id; });
        addBtn.classList.toggle('is-added', added);
        addBtn.textContent = added
          ? (addBtn.getAttribute('data-added-text') || 'Добавено')
          : (addBtn.getAttribute('data-default-text') || 'Добави това огледало');
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-product-id');
        var selections = getSelections();
        var idx = -1;
        for (var i = 0; i < selections.length; i++) {
          if (String(selections[i].id) === id) { idx = i; break; }
        }
        if (idx === -1) {
          selections.push({
            id: id,
            handle: addBtn.getAttribute('data-product-handle') || '',
            title: addBtn.getAttribute('data-product-title') || ''
          });
        } else {
          selections.splice(idx, 1);
        }
        setSelections(selections);
        refresh();
      });
    }

    refresh();
  });
})();
